import React from 'react'
import NavBar from '../features/navbar/Navbar'
import Footer from '../features/common/Footer'
import ProductMenList from '../features/productmen/components/ProductMenList'
const MenProductsPage = () => {
  return (
    <div>
        <ProductMenList></ProductMenList>
      
    </div>
  )
}

export default MenProductsPage
